// ============================================================
// Staff Policies module manifest.
//
// 2026-09-21. Owners: fullstack-lead (7-agent design synthesis) +
//   firebase-expert (impl) + data-architect (schema) + auth-security
//   (Rules + permissions plumbing) + ux-architect (IA) +
//   mobile-web-expert (rendering gates) + usability-expert (copy) +
//   hr-leave-payroll (content).
//
// READ-ONLY FOR EVERYONE, including shop-floor staff. v1 has ZERO client
// write access — publishing is Admin-SDK-only (scripts/seed-policies.js),
// and the Admin SDK bypasses Rules entirely. Published content is therefore
// immutable-by-construction from the browser: there is no client code path
// to freeze, which is a stronger guarantee than a Rules freeze and far
// cheaper than an editor UI.
//
// ONE sidebar entry in section 'people', immediately after "Apply Leave"
// (sidebarPosition 30, between leave-management 20 and attendance 40).
//
// CONTENT DOES NOT LIVE IN THE BUNDLE. Policy bodies are authored as JSON
// at scripts/seed/policies-ccy-hr-p01.json — OUTSIDE src/ and public/, never
// bundled — and imported to Firestore by the Admin-SDK seed script, exactly
// the roadmap precedent (scripts/seed/roadmap-qxd4000-starter.json). This is
// the locked SPEC_ROADMAP.md line 22 decision: "NO CCY content in the JS
// bundle (Hosting serves the bundle unauthenticated)."
// ============================================================

export default {
  id:          'policies',
  name:        'Staff Policies',
  version:     '1.0.0',
  description: 'Numbered, versioned, bilingual (English / Bahasa Malaysia) company policy library. Read-only for every role, including shop-floor staff. Policy #1 is CCY-HR-P01 Medical & Sick Leave Benefit.',

  load: () => import('./index.js'),

  routes: [
    {
      id:      'policies',
      label:   'Staff Policies',
      icon:    '📋',
      section: 'people',
      sidebarPosition: 30,
      // The 2026-05-04 sidebar-leak shape. NEVER `visible: () => true` —
      // that was the bug. The `typeof hasPerm === 'function' &&` guard
      // makes a shell that forgets to pass hasPerm fail CLOSED.
      visible: (role, hasPerm) => typeof hasPerm === 'function' && hasPerm('policies.read'),
      mount:   'mountPolicies',
      unmount: 'unmountPolicies'
    }
  ],

  schemas: [
    'policies',          // register — one doc per policy code, doc id = PolicyCode
    'policy-versions'    // one doc per version, doc id <CODE>-V<n>. The evidence object.
    // 'policy-acknowledgements' is RESERVED and DEFERRED to v1.1. It is
    // deliberately NOT listed here: the collection has an explicit
    // deny-everything Rules block, and listing a schema we do not write
    // would make the parity matrix lie.
  ],

  permissions: [
    'policies.read'
    // 'policies.acknowledge' is DELIBERATELY ABSENT until acknowledgement
    // receipts ship. Listing it would have director's `*` and admin's
    // __ALL_EXCEPT_TENANT_CONFIG__ expansion silently pick up a
    // granted-but-unenforced permission string, and it must NEVER enter
    // STOPPED_KEEP_PERMS.
  ],

  dependencies: [],

  fitsIndustries: ['manufacturing', 'trading', 'services', 'retail'],

  // DEFERRED — ux-architect designed a dashboard announcement tile; cut from
  // v1 to keep the first ship tight. The staff sidebar is ~6 items and Staff
  // Policies sits directly under Apply Leave, so discoverability is fine
  // without it.
  dashboardWidgets: []
};
